import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';
import { formatDate } from 'utils/date-helpers';
import { ResponsePromotionDto } from '../types/dtos';
import { createEmptyData } from 'constants/emptyData';

export type PromotionsQueryParams = BaseQueryParams & {
    placeId?: string;
};

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<PaginatedResponse<ResponsePromotionDto>, PromotionsQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            if (!_arg.placeId) {
                return {
                    data: createEmptyData<ResponsePromotionDto>(),
                };
            }

            const promotionResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.PROMOTIONS, _arg));

            if (promotionResponse.error) {
                return { error: promotionResponse.error };
            }

            const promotions = promotionResponse.data as PaginatedResponse<ResponsePromotionDto>;

            promotions.content = promotions.content.map((promotion) => {
                const createdAt = formatDate(promotion.createdAt);
                const startDate = promotion?.startDate ? formatDate(promotion.startDate) : '';
                const endDate = promotion?.endDate ? formatDate(promotion.endDate) : '';

                return {
                    ...promotion,
                    startDate,
                    endDate,
                    createdAt,
                };
            });
            return {
                data: promotions,
            };
        },
        providesTags: [{ type: 'promotions', id: 'GET' }],
    });
